import { useGetDataHook, useSaveDataHook } from "@bymason/api-hooks-base";
import { AppId, UpdateUserPrefsOptions, userClient } from "@bymason/controller-api";
import { useCallback } from "react";

/**
 * React hook that asynchronously gets current user's prefs.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetUserPrefs(clientToken: string) {
  const handleGetData = useCallback(
    (appId: AppId) => {
      return userClient.getUserPrefs({ appId }, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously updates current user's prefs.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useUpdateUserPrefs(clientToken: string) {
  const handleGetData = useCallback(
    (options: UpdateUserPrefsOptions) => {
      return userClient.updateUserPrefs(options, clientToken);
    },
    [clientToken]
  );

  return useSaveDataHook(handleGetData);
}
